<aside class="floating-message-item {{ item.type }}" [class.impaired]="item.impaired" [@inOutAnimation] (click)="closeNotification()">
	<h1>
		@if (item.type === 'success') {
			<mat-icon svgIcon="acies_true"></mat-icon>
		}
		@if (item.type === 'error') {
			<mat-icon svgIcon="acies_false"></mat-icon>
		}
		<span>{{ item.heading }}</span>
		<span class="date">{{ formattedDate }} &ndash; {{ formattedTime }}</span>
	</h1>
	<h2>{{ item.text }}</h2>
	<div class="progress"></div>
	<div class="close">
		<mat-icon svgIcon="acies_false"></mat-icon>
	</div>
</aside>
